import { render } from "./language-dropdown.component.vue?vue&type=template&id=7f697732&scoped=true&ts=true"
import script from "./language-dropdown.component.ts?vue&type=script&lang=ts"
export * from "./language-dropdown.component.ts?vue&type=script&lang=ts"

import "./language-dropdown.component.vue?vue&type=style&index=0&id=7f697732&lang=less&scoped=true"

import exportComponent from "/app/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f697732"]])

export default __exports__